import { useEffect, useRef, useState } from "react";
import styles from "../index.module.scss";

const ConvetiSelect = ({
  id,
  name,
  value,
  onChange,
  options,
  placeholder,
  disabled = false,
  ariaLabel,
  className = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);
  const selectedOption = options.find(
    (option) => String(option.value) === String(value),
  );

  useEffect(() => {
    if (!isOpen) return;

    const handleOutsideClick = (event) => {
      if (!selectRef.current?.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isOpen]);

  const handleSelect = (option) => {
    if (option.disabled) return;
    onChange({
      target: {
        name,
        value: option.value,
      },
    });
    setIsOpen(false);
  };

  return (
    <div
      className={`${styles.convetiSelect} ${className}`}
      ref={selectRef}
      data-open={isOpen ? "true" : "false"}
    >
      <button
        id={id}
        type="button"
        className={styles.convetiSelectButton}
        disabled={disabled}
        aria-label={ariaLabel}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((current) => !current)}
      >
        <span className={!selectedOption ? styles.convetiSelectPlaceholder : ""}>
          {selectedOption?.label || placeholder}
        </span>
        <span className={styles.convetiSelectChevron} aria-hidden="true" />
      </button>

      {isOpen && (
        <div className={styles.convetiSelectMenu} role="listbox">
          {placeholder && (
            <button
              type="button"
              role="option"
              aria-selected={!selectedOption}
              className={`${styles.convetiSelectOption} ${
                !selectedOption ? styles.convetiSelectOptionActive : ""
              }`}
              onClick={() => handleSelect({ label: placeholder, value: "" })}
            >
              {placeholder}
            </button>
          )}
          {options.map((option) => {
            const isSelected = String(option.value) === String(value);
            return (
              <button
                key={option.value}
                type="button"
                role="option"
                aria-selected={isSelected}
                disabled={option.disabled}
                className={`${styles.convetiSelectOption} ${
                  isSelected ? styles.convetiSelectOptionActive : ""
                }`}
                onClick={() => handleSelect(option)}
              >
                {option.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ConvetiSelect;
